import styles from '@/styles/productDetail/interestedProducts.module.scss'
import { useEffect, useState } from 'react'
import productApi from '@/service/modules/productApi'
import GoodsComponentWithDiscount from '@/components/GoodsComponentWithDiscount'
import SwiperMiddle from '@/components/global/SwiperMiddle'
import { SwiperSlide } from 'swiper/react'

interface ProductItem {
  productID: number;
  name: string;
  url: string;
  imgUrl?: string;

  thumbnail?: string;
  smallThumbnail?: string;
  newThumbnail?: string;
  filename?: string;

  price: number;
  normalPrice: number;

  isGroup: number;
  inStock: number;
  preSales: number;

  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  isEmailOnly: any,
  promotionTypeID: number;

  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    pointRate: string;
    promotionRate: number;
  };
  review: {
    avgRank: number;
    total: number;
  };

  [key: string]: any;
}

interface Props {
  productId : number | undefined
}

export default function InterestedProducts({ productId }: Props) {

  // 获取RecommendData
  const [recommendData, setRecommendData] = useState<ProductItem[]>([]);
  const getRecommendData = async () => {
    try {
      let res = await productApi.getRanking()
      if (res.data && res.data.pageList) {
        setRecommendData(res.data.pageList.items || [])
      }
    } catch (error) {
      console.error(error)
    }
  }

  // 页面onload再请求数据
  useEffect(() => {
    function handleWindowLoad() {
      getRecommendData()
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  const [slidesPerView, setSlidesPerView] = useState(0)
  // const [isBeginning, setIsBeginning] = useState(true)
  // const [isEnd, setIsEnd] = useState(false)

  // function onSlideChange(isBeginning: boolean, isEnd: boolean) {
  //   setIsBeginning(isBeginning)
  //   setIsEnd(isEnd)
  // }

  useEffect(() => {
    // 监听页面resize事件, 根据屏幕大小改变轮播图展示个数
    function handleResize() {
      if (window.innerWidth >= 1158) {
        setSlidesPerView(5)
      } else if (window.innerWidth >= 900) {
        setSlidesPerView(4)
      } else {
        setSlidesPerView(3)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    };
  }, [])

  return (
    <>
      {
        !!(recommendData && recommendData.length) &&
        <div className={`${styles['interested-products']}`}>
          <div className={styles['title']}>You May Be Interested In The Following Products:</div>
          {/* 轮播 */}
          <SwiperMiddle
            slidesPerView={slidesPerView}
            // slideChange={onSlideChange}
          >
            {
              (recommendData && recommendData.length) &&
              recommendData.map((item: any, index: number) => (
                <SwiperSlide key={index} style={{ padding: '0 10px' }}>
                  <div className={styles['product-list']}>
                    <GoodsComponentWithDiscount {...{ ...item, productName: item.name, imgUrl: item.newSmallPicture }} type='Recommend' />
                  </div>
                </SwiperSlide>
              ))
            }
          </SwiperMiddle>
        </div>
      }
    </>
  )
}